/* eslint-disable camelcase */
import ufeApi from 'services/api/ufeApi';
import languageLocaleUtils from 'utils/LanguageLocale';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import { ENTRYPOINTS } from 'ai/constants/superchat';
import getSotTrackingId, { appendSotTrackingIdHeader } from 'ai/utils/getSotTrackingId';

const CAMPAIGN_NAME = 'product-advisor';
const URL_PREFIX = '/gway/v1/genai-pa-entrypoint-prompts/v1/entrypoint-prompts';

const getPayload = ({
    productId, skuId, categoryId, searchTerm, entityName, page, clientId, anonymousId, ecid
}) => {
    const { getCurrentLanguage, getCurrentCountry } = languageLocaleUtils;

    const basePayload = {
        language: getCurrentLanguage()?.toLowerCase(),
        country: getCurrentCountry(),
        campaign_name: CAMPAIGN_NAME,
        atg_id: Storage.local.getItem(LOCAL_STORAGE.PROFILE_ID) || '',
        anonymous_id: anonymousId || '',
        client_id: clientId || '',
        ecid: ecid || '',
        sot_tracking_id: getSotTrackingId()
    };

    if (page === ENTRYPOINTS.PDP) {
        return {
            ...basePayload,
            data: {
                products: [
                    {
                        product_id: productId,
                        sku_id: skuId
                    }
                ],
                category_id: categoryId,
                search_term: '',
                entity_name: entityName || '',
                entrypoint: page
            }
        };
    }

    if (page === ENTRYPOINTS.DEFAULT) {
        return {
            ...basePayload,
            data: {
                entrypoint: ENTRYPOINTS.DEFAULT
            }
        };
    }

    if (page === ENTRYPOINTS.PLP) {
        return {
            ...basePayload,
            data: {
                entrypoint: page,
                category_id: categoryId,
                search_term: searchTerm,
                entity_name: entityName || ''
            }
        };
    }

    // Default to SRP payload
    return {
        ...basePayload,
        data: {
            entrypoint: page,
            category_id: categoryId,
            search_term: searchTerm
        }
    };
};

const entryPointPrompts = (token, params) => {
    const payload = getPayload(params);
    const url = `${URL_PREFIX}/${encodeURIComponent(params.page)}`;

    const headers = {
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`
    };

    appendSotTrackingIdHeader(headers);

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
};

export default entryPointPrompts;
